import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import ST10050View from "../../Views/Stock/ST10050";
import Snackbar from "../../Components/Snackbar";
import { Landscape } from "@mui/icons-material";

function ST10050(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [inputs, setInputs] = React.useState({
    ItemCd: "",
    CustItemCd: "",
    ItemNm: "",
    ItemUnit: "",
    ItemStd: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [searchDate, setSearchDate] = React.useState(new Date());
  const today = new Date();
  const monthAgo = new Date(today);
  const [startDate, setStartDate] = React.useState(
    monthAgo.setMonth(today.getMonth() - 3)
  );
  let selectedPoNo = "";
  const [endDate, setEndDate] = React.useState(new Date());
  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });

      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Stock.ST10050.GetTranList,
        {
          startDate: new Date(startDate),
          endDate: endDate,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          rowData({});
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              tranType: data[i].tranType, //
              tranNo: data[i].tranNo, //
              tranDt: data[i].tranDt
                ? data[i].tranDt.toString().replace("T", " ")
                : "", //
              itemNm: data[i].itemNm, //
              lotNo: data[i].lotNo, //
              whNm: data[i].whNm, //
              tranQty: data[i].tranQty, //
              refDocNo: data[i].refDocNo, //
              causeDesc: data[i].causeDesc, //
              createId: data[i].createId, //
              createDt: data[i].createDt
                ? Commons.DateFormating(data[i].createDt.toString(), 2)
                : "", //
            });
          }
          setRowData(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  return (
    <>
      <ST10050View
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        setSelectedRowData={setSelectedRowData}
        searchDate={searchDate}
        setSearchDate={setSearchDate}
        Init={Init}
        setStartDate={setStartDate}
        startDate={startDate}
        setEndDate={setEndDate}
        endDate={endDate}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default ST10050;
